import { Grid, GridColumn, GridRow } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';

export type SubjectContainerUsedInDataType = {
  uuid: string;
  name: string;
  lessons: Array<{
    uuid: string;
    displayName: string[];
    versions: Array<{
      uuid: string;
      version: number;
      description?: string | null;
      timetable: { name: string };
    }>;
  }>;
  curricula: Array<{ uuid: string; displayName: string[] }>;
  teachingBlocksAggregate?: {
    count: number;
  } | null;
  lessonUnitsAggregate?: {
    count: number;
  } | null;
};

type SubjectContainerUsedInProps = {
  data: SubjectContainerUsedInDataType;
};

export const SubjectContainerUsedIn = ({ data }: SubjectContainerUsedInProps) => {
  const { t } = useTranslation();

  const uniqueLessonDisplayNames = data?.lessons.reduce((acc, lesson) => {
    const displayName = lesson.displayName.join(', ');
    if (!acc.includes(displayName)) {
      acc.push(displayName);
    }
    return acc;
  }, [] as string[]);

  return (
    <>
      {data.teachingBlocksAggregate && data.teachingBlocksAggregate.count > 0 && (
        <div className={'mb-4 mt-4'}>{t('subjectContainer.hasTeachingBlock')}</div>
      )}
      {data.lessonUnitsAggregate && data.lessonUnitsAggregate.count > 0 && (
        <div className={'mb-4 mt-4'}>{t('subjectContainer.hasLessonUnits')}</div>
      )}
      {uniqueLessonDisplayNames && (
        <Grid>
          {uniqueLessonDisplayNames.length > 0 && (
            <GridRow headline={t('usedInLessons', { name: data.name, count: uniqueLessonDisplayNames.length })}>
              <GridColumn width={12}>
                {uniqueLessonDisplayNames?.map((dn) => (
                  <div key={dn}>{dn}</div>
                ))}
              </GridColumn>
            </GridRow>
          )}

          {/*
           /*
            todo we need a curricula displayName
           */
          /* {data.curricula.length > 0 && (*/}
          {/*  <GridRow headline={t('subjectContainer.usedInCurricula')}>*/}
          {/*    <GridColumn width={12}>*/}
          {/*      {data.curricula.map((curriculum) => (*/}
          {/*        <div key={curriculum.uuid}>{curriculum.curriculumClassesNames}</div>*/}
          {/*      ))}*/}
          {/*    </GridColumn>*/}
          {/*  </GridRow>*/}
          {/*)}*/}
        </Grid>
      )}
    </>
  );
};
